import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import { Text, Flex } from 'components/ui';
import RedemptionInfoSection from './RedemptionInfoSection.f';

const getText = localeUtils.getLocaleResourceFile(
    'components/Content/BeautyInsider/BeautyInsiderModules/PointsActivityDetail/locales',
    'PointsActivityDetail'
);

const formatPointsDisplay = points => {
    return points && points > 0 ? `+${points} pts` : `${points} pts`;
};

const getPointsColor = points => (points < 0 ? 'red' : 'green');

const PointActivityDetail = ({ activity }) => {
    return (
        <>
            {activity.activityTypeCode === 'CREATE' && basePurchasePointsSection(activity)}
            {isBirthdayRewardRedemption(activity.rewardName) && (
                <RedemptionInfoSection
                    image={activity.sku?.imageUrl}
                    title={activity.sku.displayText}
                    description={activity.sku.displayName}
                    link={{ text: getText('brandLink'), url: activity.sku?.url }}
                    redemptionValue={activity.rewardName}
                />
            )}
        </>
    );
};

const isBirthdayRewardRedemption = rewardName => {
    return rewardName && rewardName.toLowerCase().includes('birthday gift');
};

const basePurchasePointsSection = activity => {
    const pointsDisplay = formatPointsDisplay(activity.pointsUpdated);

    return (
        pointsDisplay && (
            <Flex
                direction='row'
                justifyContent='space-between'
                alignItems='flex-start'
                alignSelf='stretch'
                marginTop={12}
            >
                <Text
                    is='p'
                    children={activity.description1}
                ></Text>
                <Text
                    is='p'
                    fontWeight='bold'
                    children={pointsDisplay}
                    color={getPointsColor(activity.pointsUpdated)}
                />
            </Flex>
        )
    );
};

export default wrapFunctionalComponent(PointActivityDetail, 'PointActivityDetail');
